import * as React from 'react'

export const VenmoIcon = React.memo<JSX.IntrinsicElements['svg']>((props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.2998 2L28.4998 4.8C29.2998 6.7 29.8998 8.9 29.8998 12.2C29.8998 18.2 25.6998 27 22.1998 32.6L18.4998 3L3.2998 4.5L10.2998 46H27.6998C35.3998 36 44.6998 21.7 44.6998 10.8C44.6998 7.4 43.8998 4.7 42.2998 2Z"
        fill="#008CFF"
      />
    </svg>
  )
})

VenmoIcon.displayName = 'VenmoIcon'
